import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  class: "d-sm-flex align-items-center",
  style: {"width":"100%"}
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "form-group mb-15 mt-30 mb-sm-20 mb-md-25" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "col-4" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = {
  key: 0,
  class: "col-4"
}
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = { class: "col-4" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "offset-9 col-3" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "row list justify-content-center" }
const _hoisted_21 = { class: "col-lg-12 col-sm-12 text-end" }
const _hoisted_22 = { class: "p-15 bg-f2f1f9 text-end" }
const _hoisted_23 = { class: "mb-0 fw-black text-primary text-end" }
const _hoisted_24 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_25 = { class: "table-responsive" }
const _hoisted_26 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_31 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_33 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_34 = {
  key: 0,
  class: "badge text-white bg-danger fs-12"
}
const _hoisted_35 = {
  key: 1,
  class: "badge text-white bg-info fs-12"
}
const _hoisted_36 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_37 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          style: {"width":"100%"},
          class: "search-box position-relative me-15"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Field, {
                    name: "recherche",
                    type: "text",
                    modelValue: $setup.recherche,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.recherche) = $event)),
                    class: "form-control shadow-none text-black rounded-0 border-0",
                    placeholder: "Rechercher"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "recherche",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                    _createTextVNode(" Date Début "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createVNode(_component_Field, {
                    name: "debut",
                    type: "date",
                    modelValue: $setup.debut,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.debut) = $event)),
                    style: {"background-color":"#fff"},
                    class: "form-control shadow-none rounded-0 text-black",
                    placeholder: "Choisisser la date"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "debut",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                    _createTextVNode(" Date Fin "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createVNode(_component_Field, {
                    name: "fin",
                    modelValue: $setup.fin,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.fin) = $event)),
                    type: "date",
                    style: {"background-color":"#fff"},
                    class: "form-control shadow-none rounded-0",
                    placeholder: "Choisisser la date"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "fin",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                    _createTextVNode(" Mode de paiement "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createVNode(_component_Field, {
                    name: "modeleBoite",
                    modelValue: $setup.model,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.model) = $event))
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        options: $setup.modeOptionsPaiements,
                        searchable: true,
                        "no-results-text": "Aucun mode trouvé",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, { placeholder: "Sélectionner le mode de paiement" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "modeleBoite",
                    class: "text-danger"
                  })
                ])
              ]),
              (!$setup.etatAgence)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                        _createTextVNode(" Agence "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "bureau",
                        modelValue: $setup.bureau,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.bureau) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: $setup.bureausBoitesOptions,
                            searchable: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            "no-results-text": "Aucune agence trouvée"
                          }, field, { placeholder: "Sélectionner une agence" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "bureau",
                        class: "text-danger"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                    _createTextVNode(" Type de paiement"),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createVNode(_component_Field, {
                    name: "option",
                    modelValue: $setup.etat,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.etat) = $event))
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        options: $setup.etatsOptions,
                        searchable: true,
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, {
                        "no-results-text": "Aucun type trouvé",
                        placeholder: "Sélectionner un type de paiement"
                      }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "option",
                    class: "text-danger"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "d-block fw-medium text-black-emphasis fs-13 text-uppercase" }, _toDisplayString("Montant total"), -1)),
                        _createElementVNode("h4", _hoisted_23, _toDisplayString(($setup.montantTotal ? $setup.separateur($setup.montantTotal) : 0 )+ " F CFA"), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("table", _hoisted_26, [
          _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " REFERENCE "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Abonnement "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Abonné "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " MODE "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "MONTANT"),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "OBJET"),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "DATE PAIEMENT "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "STATUT"),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "AGENCE")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paiements, (paie, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_27, _toDisplayString(paie.refPaiement), 1),
                _createElementVNode("td", _hoisted_28, _toDisplayString(paie.abonnement?.refAbo), 1),
                _createElementVNode("td", _hoisted_29, _toDisplayString(paie.abonnement?.abonne?.nomComplet), 1),
                _createElementVNode("td", _hoisted_30, _toDisplayString(paie.modePaiement ? paie.modePaiement.libelle : ""), 1),
                _createElementVNode("td", _hoisted_31, _toDisplayString($setup.separateur(paie.montantPaye)), 1),
                _createElementVNode("td", _hoisted_32, _toDisplayString(paie.service ? paie.service.libelle : "Redevance"), 1),
                _createElementVNode("td", _hoisted_33, _toDisplayString($setup.format_date(paie.datePaiement)), 1),
                _createElementVNode("td", null, [
                  (paie.statut === 'Annulé')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Annulé"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_35, "Validé"))
                ]),
                _createElementVNode("td", _hoisted_36, _toDisplayString(paie.abonnement.estMPostBox == false ? paie.abonnement.boite ? paie.abonnement.boite?.bureau?.nom :
                  "" : paie.abonnement.bureau?.nom), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createVNode(_component_PaginationComponent, {
          page: $setup.page,
          totalPages: $setup.totalPages,
          totalElements: $setup.totalElements,
          limit: $setup.limit,
          onPaginate: $setup.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}